import type { ReactNode } from 'react'

import { Avatar } from '@components/atoms/Avatar'

export function GhostChip({ name, children }: { name: string; children?: ReactNode }) {
  return (
    <span className="tw:inline-flex tw:items-center tw:gap-1.5 tw:rounded-full tw:border tw:border-dashed tw:border-gray-300 tw:bg-gray-50 tw:py-0.5 tw:pl-0.5 tw:pr-0.5 tw:text-xs tw:font-medium tw:text-gray-500">
      <span className="tw:inline-flex tw:items-center tw:gap-1.5 tw:pl-0.5 tw:pr-1">
        <Avatar name={name} muted />
        <span className="tw:line-through">{name}</span>
      </span>
      {children}
    </span>
  )
}
